import CardHeader from '../CardHeader'
import './styles.scss'

const EmotionBlock = ({ emotion, title, note, className }) => (
  <div className={`notes-block ${className}`}>
    <span className={`emotion ${className}`}>{emotion}</span>
    <div className='emotion-labels'>
    <span className={`emotion-labels-title ${className}`}>{title}</span>
    <span className={`emotion-labels-note ${className}`}>{note}</span>
    </div>
  </div>
)

const EvaluationCard = ({ assistanceEvaluation, centeredHeaderTitle = true, headerTitle = "Avaliação dos meus atendimentos", className = "", classNameNotes = "", classNameEmotions = "" }) => {
  const formatScore = assistanceEvaluation && {
    veryBad: assistanceEvaluation ? Number(assistanceEvaluation[1]?.percentage || 0).toFixed(0) : 0,
    bad: assistanceEvaluation ? Number(assistanceEvaluation[2]?.percentage || 0).toFixed(0) : 0,
    regular: assistanceEvaluation ? Number(assistanceEvaluation[3]?.percentage || 0).toFixed(0) : 0,
    good: assistanceEvaluation ? Number(assistanceEvaluation[4]?.percentage || 0).toFixed(0) : 0,
    veryGood: assistanceEvaluation
      ? Number(assistanceEvaluation[5]?.percentage || 0).toFixed(0)
      : 0,
  }

  return (
    <div className={`assistance-evaluation__cards-evaluation ${className}`}>
      {/* {centeredHeaderTitle ? <CardHeader className="evaluation-header">
        <span>{headerTitle}</span>
      </CardHeader> : <CardHeader className="evaluation-header" title={headerTitle}/>} */}
      <div className={`assistance-evaluation__cards-notes ${classNameNotes}`}>
        <EmotionBlock
          emotion="😞"
          title="Muito ruim"
          note={`${(formatScore && formatScore["veryBad"]) || 0}%`}
          className={`very-bad ${classNameEmotions}`}
        />
        <EmotionBlock
          emotion="😕"
          title="Ruim"
          note={`${(formatScore && formatScore["bad"]) || 0}%`}
          className={`bad ${classNameEmotions}`}
        />
        <EmotionBlock
          emotion="😐"
          title="Regular"
          note={`${(formatScore && formatScore["regular"]) || 0}%`}
          className={`regular ${classNameEmotions}`}
        />
        <EmotionBlock
          emotion="🙂"
          title="Bom"
          note={`${(formatScore && formatScore["good"]) || 0}%`}
          className={`good ${classNameEmotions}`}
        />
        <EmotionBlock
          emotion="😃"
          title="Muito bom"
          note={`${(formatScore && formatScore["veryGood"]) || 0}%`}
          className={`very-good ${classNameEmotions}`}
        />
      </div>
    </div>
  )
}

export default EvaluationCard